import { render, staticRenderFns } from "./WebpartPage.vue?vue&type=template&id=7ca50007"
import script from "./WebpartPage.vue?vue&type=script&lang=ts"
export * from "./WebpartPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports